// src/utils/operation.utils.js

export const getOperation = (val) => {
  if (!val) return val
  return val.split('-')[1] || val
}

// normalize ANY key (partType / operationType)
export const normalizeOperationFields = (data) => {
  if (!Array.isArray(data)) {
    console.error('normalizeOperationFields: not an array', data)
    return []
  }

  return data.map((item) => {
    const cleanPartType = item?.partType
      ? item.partType.split('-')[1] || item.partType
      : item?.partType

    return {
      ...item,
      partType: cleanPartType,
      operationType: item?.operationType
        ? item.operationType.split('-')[1] || item.operationType
        : cleanPartType
    }
  })
}

// for dropdowns
export const normalizeOperationList = (ops = []) => {
  const unique = new Set()

  return ops
    .map((op) => op?.split('-')[1] || op)
    .filter((op) => {
      if (unique.has(op)) return false
      unique.add(op)
      return true
    })
    .map((op) => ({ label: op, value: op }))
}
